export function sanitizeReturnTo(raw: string | undefined, orgSlug: string): string | null {
    if (!raw || !orgSlug) return null
    let decoded: string
    try {
        decoded = decodeURIComponent(raw)
    } catch {
        return null
    }
    const expectedPrefix = `/${orgSlug}/`
    if (!decoded.startsWith(expectedPrefix)) return null
    if (decoded.includes('//') || decoded.includes('\\')) return null
    return decoded
}
